import { createFeatureSelector, createSelector } from '@ngrx/store';

import { RemitReportStatusStoreModelEnum } from '@domain/crisis-management';

import { FeatureState, featureKey } from './crisis.reducer';

export const selectFeature = createFeatureSelector<FeatureState>(featureKey);

const selectIsCrisis$ = createSelector(selectFeature, ({ isCrisis }) => isCrisis);
const selectIsLoading$ = createSelector(selectFeature, ({ isLoading }) => isLoading);
const selectIsExecuteCurtailmentLoading$ = createSelector(selectFeature, ({ isExecuteCurtailmentLoading }) => isExecuteCurtailmentLoading);
const selectIsExecuteCurtailmentFail$ = createSelector(selectFeature, ({ isExecuteCurtailmentFail }) => isExecuteCurtailmentFail);
const selectOutageDetails$ = createSelector(selectFeature, ({ outageDetails }) => outageDetails);
const selectIsOutageDetailsLoading$ = createSelector(selectFeature, ({ isOutageDetailsLoading }) => isOutageDetailsLoading);
const selectIsReportStatusInProgressOrWillBe$ = createSelector(selectFeature, (state) => {
  return (
    (state.outageDetails && !state.outageDetails.remitReports?.length) ||
    state.outageDetails?.remitReports.some(({ status }) => status === RemitReportStatusStoreModelEnum.IN_PROGRESS)
  );
});
const selectCurtailment$ = createSelector(selectFeature, ({ curtailment }) => curtailment);
const selectIsCurtailmentLoading$ = createSelector(
  selectFeature,
  ({ isCurtailmentLoading, isOutageDetailsLoading }) => isCurtailmentLoading || isOutageDetailsLoading
);
const selectIsFilesLoading$ = createSelector(selectFeature, ({ isFilesLoading }) => isFilesLoading);
const selectFiles$ = createSelector(selectFeature, ({ files }) => files);

const selectMessages$ = createSelector(selectFeature, ({ messages }) => messages);
const selectIsMessagesLoading$ = createSelector(selectFeature, ({ isMessagesLoading }) => isMessagesLoading);

export const fromCrisis = {
  selectIsCrisis$,
  selectIsLoading$,
  selectIsExecuteCurtailmentLoading$,
  selectIsExecuteCurtailmentFail$,
  selectOutageDetails$,
  selectIsOutageDetailsLoading$,
  selectIsReportStatusInProgressOrWillBe$,
  selectCurtailment$,
  selectIsCurtailmentLoading$,
  selectMessages$,
  selectIsMessagesLoading$,
  selectIsFilesLoading$,
  selectFiles$,
};
